export const cantons = [
    { stc: 'suisse', code: 'CH', id: 0, name: 'Suisse' },
    { stc: "appenzelloise (R.-E.)", code: 'AR', id: 15, name: 'Appenzell R.-E.' },
    { stc: "appenzelloise (R.-I.)", code: 'AI', id: 16, name: 'Appenzell R.-I.' },
    { stc: "argovienne", code: 'AG', id: 19, name: 'Argovie' },
    { stc: 'bernoise', code: 'BE', id: 2, name: 'Berne' },
    { stc: 'bâloise (campagne)', code: 'BL', id: 13, name: 'Bâle-Campagne' },
    { stc: 'bâloise (ville)', code: 'BS', id: 12, name: 'Bâle-Ville' },
    { stc: 'fribourgeoise', code: 'FR', id: 10, name: 'Fribourg' },
    { stc: 'genevoise', code: 'GE', id: 25, name: 'Genève' },
    { stc: 'glaronnaise', code: 'GL', id: 8, name: 'Glaris' },
    { stc: 'grisonne', code: 'GR', id: 18, name: 'Grisons' },
    { stc: 'jurassienne', code: 'JU', id: 26, name: 'Jura' },
    { stc: 'lucernoise', code: 'LU', id: 3, name: 'Lucerne' },
    { stc: 'neuchâteloise', code: 'NE', id: 24, name: 'Neuchâtel' },
    { stc: 'nidwaldienne', code: 'NW', id: 7, name: 'Nidwald' },
    { stc: 'obwaldienne', code: 'OW', id: 6, name: 'Obwald' },
    { stc: 'saint-galloise', code: 'SG', id: 17, name: 'Saint-Gall' },
    { stc: 'schaffhousoise', code: 'SH', id: 14, name: 'Schaffhouse' },
    { stc: 'schwytzoise', code: 'SZ', id: 5, name: 'Schwyz' },
    { stc: 'soleuroise', code: 'SO', id: 11, name: 'Soleure' },
    { stc: 'tessinoise', code: 'TI', id: 21, name: 'Tessin' },
    { stc: 'thurgovienne', code: 'TG', id: 20, name: 'Thurgovie' },
    { stc: 'uranaise', code: 'UR', id: 4, name: 'Uri' },
    { stc: 'valaisanne', code: 'VS', id: 23, name: 'Valais' },
    { stc: 'vaudoise', code: 'VD', id: 22, name: 'Vaud' },
    { stc: 'zougoise', code: 'ZG', id: 9, name: 'Zoug' },
    { stc: 'zurichoise', code: 'ZU', id: 1, name: 'Zurich' },
  ]